jQuery(function($) {
  if (!$(".expandable_content").length) return;

  var expandableContent = $(".expandable_content");
  var toggles = expandableContent.find(".toggle");

  toggles.click(function() {
    var prev = $(this).prev();
    var siblings = prev.siblings("div:visible");
    var next = siblings.next();
    if ($body.hasClass("page-template-page-faq") && siblings.length) {
      siblings.slideUp();
      prev.slideDown();
      prev.focus();
      $(this).text("Close Details");
      next.text("View Details");
    } else if (prev.is(":visible")) {
      prev.slideUp();
        if($body.hasClass("page-template-page-faq")) {
          $(this).text("View Details");
        } else {
          $(this).text("Read More");
        }
    } else {
      prev.slideDown();
      prev.focus();
      if($body.hasClass("page-template-page-faq")) {
        $(this).text("Close Details");
      } else {
        $(this).text("Close");
      }
      
    }
  });
});
